/**
 * Заголовок paywall-шторки: «Генерация изображений доступна в Pro».
 *
 * Название функции приходит из GET /topics, поэтому «доступна/доступно/доступен»
 * приходится согласовывать на фронте. Утилита временная: как только бэк начнёт
 * отдавать готовый заголовок вместе с топиком, её можно удалить.
 */

/**
 * Форма краткого прилагательного «доступен» по первому слову названия.
 *
 * Смотрим только на первое слово: в «Генерация изображений» оно и есть вершина, а в
 * «Эмоциональная поддержка» это согласованное прилагательное — род у него тот же, что
 * у вершины. Второе слово (обычно родительный падеж: «изображений», «музыки») род не
 * определяет, поэтому его игнорируем.
 *
 * Двухбуквенные окончания проверяются первыми — иначе «Умные» уйдёт в «-е» → «доступно».
 * «-ие» намеренно не считаем множественным: у топиков это отглагольные существительные
 * среднего рода («Редактирование»), а не прилагательные («синие»).
 */
function availabilityForm(name: string): string {
	const word = name.toLowerCase().split(/\s+/)[0] ?? ''
	if (word.endsWith('ая') || word.endsWith('яя')) return 'доступна'
	if (word.endsWith('ые')) return 'доступны'
	if (word.endsWith('ый') || word.endsWith('ий') || word.endsWith('ой')) return 'доступен'
	if (word.endsWith('а') || word.endsWith('я')) return 'доступна'
	if (word.endsWith('о') || word.endsWith('е')) return 'доступно'
	if (word.endsWith('и') || word.endsWith('ы')) return 'доступны'
	return 'доступен'
}

export function proAvailabilityTitle(name: string): string {
	const trimmed = name.trim()
	// Имя топика может не прийти (гейт вызван не из плитки) — общая формулировка.
	if (!trimmed) return 'Эта функция доступна в Pro'
	return `${trimmed} ${availabilityForm(trimmed)} в Pro`
}
